import { render } from "./ListHeader.vue?vue&type=template&id=21f4eb2c&scoped=true"
import script from "./ListHeader.vue?vue&type=script&lang=js"
export * from "./ListHeader.vue?vue&type=script&lang=js"

import "./ListHeader.vue?vue&type=style&index=0&id=21f4eb2c&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\DGWA\\Documents\\tokyo-shoseki_R8_042024\\08k\\08k_sigb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f4eb2c"]])

export default __exports__